import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

  .MuiFormControl-root:hover .MuiInputLabel-outlined{
    color: #555555;
    border-width: 1px;
  }
  .MuiInputBase-formControl:hover .MuiOutlinedInput-notchedOutline{
    border-color: #555555;
    border-width: 1px;
  }

  .MuiFormLabel-filled,.MuiFormLabel-filled ~ div fieldset,
  .MuiFormLabel-filled ~ div input.MuiOutlinedInput-input, 
  .MuiFormLabel-filled ~ div textarea.MuiOutlinedInput-inputMultiline, 
  .MuiFormLabel-filled ~ div select.MuiOutlinedInput-input,
  .MuiFormLabel-filled ~ div select.MuiOutlinedInput-inputSelect{
    border-color: #555555;
    color:  #555555;
  }
  .Mui-focused ~ div select.MuiOutlinedInput-input,
  .Mui-focused ~ div select.MuiOutlinedInput-inputSelect,
  .Mui-focused ~ div input.MuiOutlinedInput-input, 
  .Mui-focused ~ div textarea.MuiOutlinedInput-inputMultiline,.selectKey{
    color:  #555555; 
  }

 .MuiOutlinedInput-notchedOutline {
    color: #555555;
    border-color: #555555;
  }
  .MuiFormHelperText-root {
    color: #8E8E8E;
  }

  .MuiFormLabel-root {
    color: #555555;
  }

  .MuiFormLabel-root.Mui-disabled {
    color: #555555;
  }
  .MuiFormLabel-root.Mui-focused {
    color: #555555;
  }

  .MuiAutocomplete-popupIndicator {
    .MuiSvgIcon-root {
      color: #00C8FF
    }
  }

  .MuiList-padding {
    padding-top: 0px;
    padding-bottom: 0px;
 }

  .MuiList-root {
    width: 100%;
    color: #565656;
    height: 56px;
    .MuiListItem-root {
      height: 56px;
    }
    svg {
        color: #4cc5f2 ;
    }
    .MuiListItem-gutters {
        border: 1px solid #555555;
        padding-left: 10px
        padding-right: 10px
        border-radius: 5px;
    }
    .MuiCollapse-container {
      position: absolute;
      width: 100%;
      min-width: 300px;
      background: white;
      z-index: 100;
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.17), 0 10px 10px 0 rgba(0,0,0,0.1);
      padding-top: 4px;
      padding-bottom: 4px;
      .MuiList-root {
        color: #565656;
        height: auto;
    }
    .MuiCollapse-wrapperInner {
      width: 100%;
      .MuiListItem-gutters {
          border: none;
          padding-left: 16px
          padding-right: 16px;
          border-radius: 0px;
          padding-top: 6px;
          padding-bottom: 6px;
          
      }
      .MuiListItem-root:hover {
        background: #DCDCDC;
        cursor: pointer;
      }
    }
    svg {
      color: black;
    }
}
  
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.align || 'flex-end'};
  margin: 10px 0px 0px 0px;
  button {
    width: 124px;
    height: 36px;
    min-height: 30px;
    max-width: 124px;
    border-radius: 18px;
    box-shadow: none;
  }
  .cancel {
    color: #00c8ff;
    margin: 10px 0px;
  }
`;
export const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  width: 100%;
`;

export const AddNew = styled.div`
  display: flex;
  align-items: center;
  border: 1px dashed #dcdcdc;
  border-radius: 3px;
  flex-wrap: no-wrap;
  width: 100%;
  height: 45px;
  margin: 10px 0px;
  color: #00c8ff;
  font-size: 24px;
  padding-left: 10px;
  box-sizing: border-box;
  &:before {
    content: '+';
  }
  &:active {
    opacity: 0.5;
  }
`;

export const RemoveButton = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: no-wrap;
  margin: 10px 0px;
  margin-right: 10px;
  color: #f01e46;
  font-size: 24px;
  &:before {
    content: '—';
  }
  &:active {
    opacity: 0.5;
  }
`;

export const CheckboxWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
  .MuiFormGroup-root {
    width: 100%;
  }
  .MuiTypography-body1 {
    color: #565656;
  }
`;

export const Fieldset = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  Mui-error {
    color: #f01e46;
  }
`;

export const InputListTitle = styled.div`
  color: #00377d;
  margin-bottom: 10px;
  font-size: 20px;
`;

export const Divider = styled.hr`
  height: 1px;
  margin: 20px 0px;
  border: none;
  background-color: rgba(0, 0, 0, 0.12);
  width: 100%;
`;

export const LabelLinkContainer = styled.div`
  margin-top: 7px;
  margin-bottom: 0px;
  span {
    font-size: 12px;
    display: block;
    @media (min-width: 1224px) {
      display: inline;
      margin-top: 20px;
    }
  }
`;

export const LinkLabelText = styled.span`
  color: #565656;
`;

export const LinkLabel = styled.span`
  color: #00c8ff;
  cursor: pointer;
`;

export const ErrorIcon = styled.span`
  svg {
    color: #f01e46;
  }
`;
